(function () {
  'use strict';

  angular
      .module('tfc.sso',
      [
        'tfc.sso.Auth',
        'tfc.sso.tmpls',
        'tfc.Toast',
        'tfc.Nav',
        'tfc.Form'
      ])
      .config(config)
      .run(run);

  // @ngInject
  function config($stateProvider, NavProvider, $provide) {

    NavProvider.addRight({
      state : 'logout',
      // @ngInject
      getText : function (TextUtil) {
        return TextUtil.translateOr('auth.logout', function () {
          return 'Log Out';
        });
      }
    });

    $stateProvider
        .state('login', {
          parent: 'page',
          data : {
            auth : { isPublic : true }
          },
          url : '/login?dest',
          templateUrl : 'sso/Login.tmpl.html',
          controller : 'LoginCtrl as vm'
        })
        .state('logout', {
          url : '/logout',
          template : '',
          resolve : {
            logout : function ($state, Auth) {
              return Auth.logout().finally(function () {
                $state.go('login');
              });
            }
          }
        })
        .state('passwordReset', {
          parent : 'page',
          url : '/password/reset',
          templateUrl : 'sso/PasswordReset.tmpl.html',
          controller : 'PasswordResetCtrl as vm'
        })
        .state('passwordResetPublic', {
          parent : 'page',
          url : '/password/resetpub?email',
          data : {
            auth : { isPublic : true }
          },
          templateUrl : 'sso/PasswordResetPublic.tmpl.html',
          controller : 'PasswordResetCtrl as vm'
        })
        .state('forgotPassword', {
          parent : 'page',
          url : '/password/forgot?email&{expired:bool}',
          data : {
            auth : { isPublic : true }
          },
          templateUrl : 'sso/ForgotPassword.tmpl.html',
          controller : 'ForgotPasswordCtrl as vm'
        })
        .state('recoverPassword', {
          parent : 'page',
          // IMPORTANT: This MUST match the url in ForgotPasswordEmail.scala
          url : '/password/recover?t',
          data : {
            auth : { isPublic : true }
          },
          resolve : {
            email : function ($state, $stateParams, Auth) {
              return Auth.getEmailByPasswordToken($stateParams.t).then(null, function () {
                $state.go('forgotPassword', { expired : true });
              });
            }
          },
          templateUrl : 'sso/RecoverPassword.tmpl.html',
          controller : 'RecoverPasswordCtrl as vm'
        })
    ;

    $provide.decorator('$state', function ($delegate, $injector) {
      /**
       * @name $state#can
       * Add this function to the $state service so it can be used in the application.
       *
       * To add access to control to a state, add a data.auth property to the state config:
       * $stateProvider.state('foo', {
       *   data : {
       *     auth : {
       *       // privilege required to view the foo state
       *       privilege : 'somePrivilege',
       *       // redirect to 'some.state' if the user tries to go here w/o the required privilege. defaults to dashboard
       *       defaultTo : 'some.state'
       *     }
       *   },
       *   ...
       * @param stateName String The state to check
       * @returns Boolean If the user can access this state.
       */
      $delegate.can = function (stateName) {
        // Avoid circular dependency
        var Auth = $injector.get('Auth');
        var state = $delegate.get(stateName);
        var privilege = _.get(state, 'data.auth.privilege');
        return !privilege || Auth.can(privilege);
      };

      return $delegate;
    });
  }

  // @ngInject
  function run($rootScope, $state, Auth, $log, Toast, TextUtil) {
    // Make sure the current JWT is still valid
    var validatePromise = Auth.validate();

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!Auth.hasValidated()) {
        event.preventDefault();
        if (!validatePromise) {
          // Re-validate after logging out
          validatePromise = Auth.validate();
        }
        validatePromise.finally(function () {
          // This prevents an infinite loop after logging out
          validatePromise = null;
          $state.go(toState.name, toParams);
        });
      } else {
        var isAuthenticated = Auth.isAuthenticated();

        // If they hit the login page but are already authenticated, just go to the app's default state
        if (isAuthenticated && toState.name === 'login') {
          event.preventDefault();
          $rootScope.$broadcast('auth.login');
        } else if (_.get(toState, 'data.auth.isPublic')) {
          return;
        }

        if (!isAuthenticated) {
          $log.debug('Not authenticated. Redirecting to Login');
          event.preventDefault();
          $state.go('login', { dest : $state.href(toState.name, toParams) });
        } else if (!$state.can(toState.name)) {
          event.preventDefault();
          var defaultTo = _.get(toState, 'data.auth.defaultTo');
          Toast.warn(TextUtil.translateOr('auth.error.lackPrivilege', function () {
            return 'Sorry, you do not have permission to do that.';
          }));
          if (defaultTo) {
            $state.go(defaultTo);
          }
        }
      }
    });
  }

})();
